import React, { useState } from "react";
import { Hero } from "./components/Hero";
import { IntroSection } from "./components/IntroSection";
import { VideoManifesto } from "./components/VideoManifesto";
import { LabSection } from "./components/LabSection";
import { ProductSection } from "./components/ProductSection";
import { Convivialita } from "./components/Convivialita";
import { Filosofia } from "./components/Filosofia";
import { FAQ } from "./components/FAQ";
import { CTAFinal } from "./components/CTAFinal";
import { Recensioni } from "./components/Recensioni";
import { Navigatore } from "./components/Navigatore";
import { SocialFollow } from "./components/SocialFollow";
import { Footer } from "./components/Footer";
import { StickyMobileCTA } from "./components/StickyMobileCTA";
import { ReservationModal } from "./components/ReservationModal";
import { CTABand } from "./components/CTABand";
import { MenuIntermezzo } from "./components/MenuIntermezzo";
import { AdminReservations } from "./components/AdminReservations";
import { LanguageProvider } from "./i18n/LanguageContext";
import { ASSETS } from "./lib/api";

function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const openReserve = () => setModalOpen(true);
  const closeReserve = () => setModalOpen(false);

  // Lightweight client-side routing: /admin renders the dashboard
  const isAdmin = typeof window !== "undefined" && window.location.pathname.startsWith("/admin");
  if (isAdmin) {
    return (
      <LanguageProvider>
        <AdminReservations />
      </LanguageProvider>
    );
  }

  return (
    <LanguageProvider>
      <div className="bg-[var(--pn-black)] text-[var(--pn-cream)] min-h-screen relative">
      <Hero onReserve={openReserve} />
      <IntroSection />
      <VideoManifesto />
      <LabSection />

      <CTABand tone="wine" testId="cta-band-after-lab" />

      {/* PRODOTTO 1 — Attimosphera */}
      <ProductSection
        index={1}
        testId="product-attimosphera"
        productKey="attimosphera"
        mediaType="duo"
        mediaPrimary={ASSETS.attimosphere1}
        mediaSecondary={ASSETS.attimosphere4}
        side="left"
        bg="noir"
      />

      {/* PRODOTTO 2 — Picanha e Pata Negra */}
      <ProductSection
        index={2}
        testId="product-picanha"
        productKey="picanha"
        mediaType="duo"
        mediaPrimary={ASSETS.picanhaSmoke}
        mediaSecondary={ASSETS.picanhaClose}
        side="right"
        bg="wine"
      />

      {/* PRODOTTO 3 — Filo di Fumo */}
      <ProductSection
        index={3}
        testId="product-filo-fumo"
        productKey="filofumo"
        mediaType="duo"
        mediaPrimary={ASSETS.filoFumo}
        mediaSecondary={ASSETS.filoFumoCheese}
        side="left"
        bg="noir"
      />

      {/* PRODOTTO 4 — Salsiccia Messinese */}
      <ProductSection
        index={4}
        testId="product-salsiccia"
        productKey="salsiccia"
        mediaType="duo"
        mediaPrimary={ASSETS.salsiccia2}
        mediaSecondary={ASSETS.salsiccia1}
        side="right"
        bg="wine"
      />

      {/* PRODOTTO 5 — Salsa al Whisky */}
      <ProductSection
        index={5}
        testId="product-salsa-whisky"
        productKey="whisky"
        mediaType="whisky"
        side="left"
        bg="noir"
      />

      <MenuIntermezzo />

      <Convivialita />
      <Filosofia />
      <CTABand tone="noir" testId="cta-band-before-faq" />
      <FAQ />
      <CTAFinal onReserve={openReserve} />
      <Recensioni />
      <Navigatore />
      <CTABand tone="wine" testId="cta-band-before-social" />
      <SocialFollow />
      <Footer />

      <StickyMobileCTA onReserve={openReserve} />
      <ReservationModal open={modalOpen} onClose={closeReserve} />
      </div>
    </LanguageProvider>
  );
}

export default App;
